import apiClient from "services/axios";

const API = {
  getStats: "/api/v1/dashboards/stats",
};

export const getDashboardStats = async (filter) => {
  const response = await apiClient.get(API.getStats, { params: filter });
  if (response) {
    return response.data;
  }
  return false;
};
